import { Link } from "react-router-dom";

import { postTrackingData } from "@/api/endpoints/track";
import { useInsightView } from "@/hooks/useInsightView";
import { useSheetLink } from "@/hooks/useSheetFilterParams";
import { cn } from "@/lib/utils";
import { EVENT } from "@/tracking_events";
import { SearchFilterV4 } from "@/types/SearchFilter";

export default function SheetLink({
  overrides,
  widget,
  action,
  className,
  children,
}: {
  overrides: Partial<SearchFilterV4>;
  widget: string;
  action: string;
  className?: string;
  children: React.ReactNode;
}) {
  // URL state
  const insight = useInsightView();
  const getSheetLink = useSheetLink();

  // Handlers
  function handleClick() {
    postTrackingData(EVENT.WIDGET_CLICK, { insight, widget, action });
  }

  return (
    <Link
      replace
      to={getSheetLink({ overrides })}
      onClick={handleClick}
      className={cn("hover:underline underline-offset-4", className)}
    >
      {children}
    </Link>
  );
}
